module.exports = __webpack_public_path__ + "static/media/downloadbook.2f1eeef7.png";